/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActiveTab/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Images from './Images/index'
import React from 'react'
import ToothChart from './ToothChart/index'



/** @type {import('Simple/types.js').View} */
export default function ActiveTab({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Images'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Images'}>
<Images
  viewPath={`${viewPath}/Images`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ToothChart'}>
<ToothChart
  viewPath={`${viewPath}/ToothChart`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}